import React, { useRef } from 'react';
import { useRootSelector } from 'common/features/featuresReducer';

import {
    IAutocompleteParameters,
    SearchParameters,
    IBrowseParameters,
    RecommendationsParameters,
} from '@constructor-io/constructorio-client-javascript/lib/types';
import { createSelector } from 'reselect';
import { selectDefaultOrganization } from 'common/features/store/duck/home/duck';
import { IS_FLIPGIVE } from 'common/env';

export const selectOrgIdAndState = createSelector(
    selectDefaultOrganization,
    (defaultOrganization) => {
        if (defaultOrganization) {
            return [defaultOrganization.id, defaultOrganization.address?.state];
        }
        return [];
    }
);

export const useConstructorDefaultParameters = <
    T extends
        | SearchParameters
        | IBrowseParameters
        | IAutocompleteParameters
        | RecommendationsParameters
>(
    extraParams: T
) => {
    const [orgId, state] = useRootSelector(selectOrgIdAndState);
    const isShipToCoordinatorEnabled = useRootSelector(
        (s) => s.store.organization.options?.isShipToCoordinatorEnabled
    );

    const defaultFilters = useRef<T>({} as T);
    const filters = {
        OrganizationId: ['0', orgId],
        IsAvailableForVirtualOnly: !isShipToCoordinatorEnabled ? ['True'] : undefined,
        ...extraParams.filters,
    };

    if (!IS_FLIPGIVE) {
        filters.AllowedStates = [state];
    }

    defaultFilters.current = {
        ...extraParams,
        filters,
    } as T;
    return defaultFilters;
};
